<template >
    <div id="tabs-footer">
        <CutawayFloorsFooter
            v-if="data.type ==='cutaway' && !data.activeHotspot" 
            :data="data"
        /> 
        <RoomItemsFooter
            v-if=" data.type ==='configurable-tour'"
            :data="data"
        />
    </div>
</template>

<script>
    import CutawayFloorsFooter from '@/layout/alternative/cutaway/components/CutawayFloorsFooter';
    import RoomItemsFooter from '@/layout/alternative/configurableTour/components/RoomsItemsFooter';

    export default {
        name: "FooterLayout",
        components:{
            CutawayFloorsFooter,
            RoomItemsFooter
        },
        props: {
            data: {
                type: Object,
                required: true
            }
        },
    };
</script>




// WEBPACK FOOTER //
// src/layout/alternative/layout/FooterLayout.vue